var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnBwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.34 -244.69)",
    "data-name": "Grupo 154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.344,276.469v-3.723c.119-.744.248-1.486.356-2.231a29.963,29.963,0,0,1,52.952-14.694,29.362,29.362,0,0,1,5.952,25.2,28.971,28.971,0,0,1-10.109,16.649,29.321,29.321,0,0,1-16.5,6.782c-.591.053-1.178.157-1.767.237h-1.683c-.231-.048-.461-.11-.695-.142-1.622-.222-3.27-.327-4.865-.674a29.913,29.913,0,0,1-23.281-25.047C219.6,278.039,219.466,277.255,219.344,276.469Zm39.331,2.1-9.371,9.333-9.29-9.3-5.325,5.341L249.4,298.65,264.1,283.986Zm-18.666-7.839,9.374-9.378,9.325,9.319,5.333-5.336L249.32,250.653l-14.706,14.688Zm9.293,9.905,6.044-6.037-5.939-5.848-6.017,5.97ZM235.916,274.7l-5.322-5.323-5.218,5.215,5.322,5.318Zm37.531.01-5.373-5.382-5.249,5.27,5.364,5.364Z",
    fill: "#e2bd00",
    "data-name": "Trazado 1046"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-112.11 -247.76)",
    d: "m370.79 526.32 5.423 5.416-14.694 14.673-14.715-14.716 5.325-5.344 9.29 9.31z",
    fill: "#fff",
    "data-name": "Trazado 1047"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-111.57 -43.598)",
    d: "m351.58 314.35-5.4-5.4 14.706-14.7 14.721 14.7-5.333 5.339-9.325-9.324z",
    fill: "#fff",
    "data-name": "Trazado 1048"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-175.68 -175.96)",
    d: "m424.99 456.61-5.912-5.918 6.018-5.974 5.939 5.851z",
    fill: "#fff",
    "data-name": "Trazado 1049"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-44.073 -180.48)",
    d: "m279.99 455.18-5.217 5.213-5.322-5.321 5.218-5.218z",
    fill: "#fff",
    "data-name": "Trazado 1050"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-317.68 -180.12)",
    d: "m591.13 454.83-5.258 5.255-5.365-5.367 5.249-5.273z",
    fill: "#fff",
    "data-name": "Trazado 1051"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnBwhite);
export default __webpack_public_path__ + "static/media/BNBwhite.5016c8677023a91aace8412048ca4596.svg";
export { ForwardRef as ReactComponent };